import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'proxy-polyfill';
import ReactDOM from 'react-dom';
import dataProviderFactory from './dataProvider';
import App from './App';

import unregisterSW from './dummySW'

// import * as serviceWorkerRegistration from './serviceWorkerRegistration';

/**
 * This demo can work with either a fake REST server, or a fake GraphQL server.
 *
 * To avoid bundling both libraries, the dataProvider and fake server factories
 * use the import() function, so they are asynchronous.
 */
const prepareDataProvider = async () => {
    // const restoreFetch = await fakeServerFactory(
    //     process.env.REACT_APP_DATA_PROVIDER || ''
    // );
    const restoreFetch = () => null
    const dataProvider = await dataProviderFactory(
        process.env.REACT_APP_DATA_PROVIDER || ''
    );

    return { dataProvider, restoreFetch };
};

prepareDataProvider().then(({ dataProvider, restoreFetch }) => {
    ReactDOM.render(
        <App dataProvider={dataProvider} onUnmount={restoreFetch} />,
        document.getElementById('root')
    );
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// serviceWorkerRegistration.register();

// hack remove all service workers
unregisterSW()
